import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Competition } from 'pkg/api/models/competition';
import type { Dateable } from 'pkg/api/models/dateable';
import type { GameTeam } from 'pkg/api/models/game_team';
import type { SportType } from 'pkg/api/models/sport';

import type {
	MaterialSymbolVariant,
} from 'components/material-symbols/symbols';

type GameFormat = string;

type GameSurface = string;

export enum GameOutcome {
	Win = 'win',
	Loss = 'loss',
	Draw = 'draw',
}

export interface GameSetup {
	periods: number;
	periodLength: number;
	format: GameFormat;
	surface: GameSurface;
	friendlyGame: boolean;
	overtimeType?: string;
	overtimeLength?: number;
}

export interface Game extends GameSetup, Dateable, AllowedActionable {
	id: number;
	userID: number;
	groupID: number;
	eventID: number;
	title: string;
	location: string;
	description: string;
	sportType: SportType;
	externalID: string;
	competitionId: number;
	homeGameTeamId: number;
	awayGameTeamId: number;
	startsAt: number;
	competition: Competition;
	homeGameTeam: GameTeam;
	awayGameTeam: GameTeam;
}

export interface FormationPosition {
	label: string;
	position: string;
	labelShort: string;
}

export interface Formation {
	format: string;
	formation: string;
	label?: string;

	// Formations are grouped "vertically" and then "horizontally" in a nested array manner, an array of arrays with objects.
	positions: FormationPosition[][];
}

export interface PositionGroup {
	position: string;
	group: string;
	label?: string;
	labelShort?: string;
}

export interface FormationsResult {
	formations: Formation[];
	positionGroups: PositionGroup[];
	color: string;
	colorIntensity: number;
}

export interface GameOverviewTeamResponse {
	id: number;
	groupId?: number;
	score: number;
	firstPeriodScore?: number;
	name: string;
	profileImageUrl?: string;
	players?: { id: number; name: string; profileImageUrl?: string }[];
	value: number;
}

export interface GameOverviewField {
	id: string;
	icon: MaterialSymbolVariant;
	label: string;
	timezone?: string;
	time?: number;
}

export interface GameOverview extends AllowedActionable {
	id: number;
	groupId: number;
	eventId?: number;
	homeTeam: GameOverviewTeamResponse;
	awayTeam: GameOverviewTeamResponse;
	isFriendly: boolean;
	fields?: GameOverviewField[];
	sportType: SportType;
	outcome?: GameOutcome;
	periodScoreSummary?: string;
}

export interface ListCompetition {
	id: number;
	title: string;
}
